module.exports = __webpack_public_path__ + "static/media/home.ce919f79.png";